import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import { TakkImage } from "../components/takk-image";
import { useTakkToday } from "../hooks/takk";

export function TakkToday() {
  // get code from query params
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");

  if (!code) {
    throw new Error("No code provided");
  }
  const { data: takkToday } = useTakkToday(code);

  const takkTodayWithAuthUrl = useMemo(() => {
    return takkToday?.map((takk) => ({
      ...takk,
      imageUrl: `${takk.imageUrl}&asRoot=true&code=${code}`,
    }));
  }, [takkToday]);

  return (
    <div className="my-5 flex flex-col gap-4 justify-center items-center">
      {takkTodayWithAuthUrl?.map((takk) => (
        <TakkImage key={takk.id} takk={takk} withLabel={false} />
      ))}
    </div>
  );
}
